import React, { useMemo, useState, useEffect } from "react";
import Customtable from "../../helper/Customtable";
import Swal from 'sweetalert2';
import { post } from "../../helper/api_helper"

const Tobacco_product_type = () => {
    const [tobacco_product_typeList, settobacco_product_typeList] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                label_condition: 's_no',
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: 'Tobacco Product Type',
                accessorKey: 'tobacco_product_type_name',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Status',
                accessorKey: 'status',
                enableColumnFilter: false,
                enableSorting: true,
                label_condition: 'status',
            },
        ],
        []
    );

    const showAlert = (icon, title, text, timer = 2000) => {
        Swal.fire({ icon, title, text: text || 'Something went wrong.', timer, showConfirmButton: false });
    };

    const fetchData = async () => {
        try {
            const response = await post("/masters/tobacco_product_type_list");
            if (response.status === 200) {
                settobacco_product_typeList(response.data);
            } else {
                showAlert('error', response.status, response.message);
            }
        } catch (err) {
            showAlert('error', 'Unexpected Error', err.message);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
       <React.Fragment>
      <div className="row">
        <div className="col-lg-6">
          <div className="card basic-data-table">
            <div className="card-header">
              <h5 className="card-title mb-0">Tobacco Product Type List</h5>
            </div>
            <div className="card-body">
              <Customtable
                table_title="Tobacco Product Type List"
                columns={columns}
                data={tobacco_product_typeList}
                isGlobalFilter={true}
                isPagination={true}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                isExportButton={true}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
    );
};

export default Tobacco_product_type;
